import styled from '@emotion/styled'
import { Button, colors, Label, spacing } from '@retailer-platform/shared-components'

export const ShiftDetailsFormContainer = styled.div({
  flex: '1 1 auto',
  alignItems: 'center',
  overflow: 'visible',
  minHeight: '260px',
  width: '344px',
  borderRadius: '12px',
  padding: spacing.X16,
})

export const ShiftForm = styled.form({
  width: '100%',
})

export const FormRow = styled.div({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '100%',
  marginBottom: spacing.X24,
})

export const TimeRangeDropDownContainer = styled.div({
  display: 'flex',
  flexGrow: 1,
  flexDirection: 'column',
  ':first-child': {
    marginRight: '12px',
  },
})

export const StyledDropdownContainer = styled.div({
  flexDirection: 'column',
  width: '100%',
})

export const StyledLabel = styled(Label)({
  color: colors.GRAYSCALE.X50,
  fontSize: '15px',
  paddingRight: '10px',
  marginBottom: spacing.X8,
  fontWeight: 600,
  display: 'flex',
  columnGap: '8px',
})

export const StyledCheckboxContainer = styled.div({
  display: 'flex',
  width: '100%',
  padding: '5px 10px',
})

export const StyledCheckbox = styled.input({
  marginRight: '10px',
})

export const StyledError = styled.span({
  color: colors.DETRIMENTAL.DARK,
})

export const StyledErrorMessage = styled.div({
  color: colors.DETRIMENTAL.REGULAR,
  margin: `${spacing.X12} auto`,
  fontSize: '15px',
})

interface ButtonProps {}

const StyledButton = styled(Button)<ButtonProps>({
  width: '150px',
  height: '40px',
})

export const StyledDeleteButton = styled(StyledButton)({})

export const StyledCancelButton = styled(StyledButton)({})

export const StyledSubmitButton = styled(StyledButton)({})
